import styled from 'styled-components';
import { Box } from '@mui/material';



       export const QuoteRequestWrapper = styled(Box)`
            
               border: 1px solid #1B4A83;
border-radius: 5px;
    width: 40%;
    .quoteInput{
        display: flex;
        padding: 20px 0px 0px 20px;
        text-align: left;            
            margin-bottom: 20px;
            margin-top: 50px;
        h4{
            margin: 0;
            color:#1B4A83;
            font-weight: 500;
                padding-left: 6px;
                    padding-bottom: 6px;
        }
       
            
    }
    .quoteText{
        padding-left:14px;
        padding-right:10px;
    }
            
            `;